module.exports = __webpack_public_path__ + "img/edscan.51cb2c6e.png";